import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "27",
  height: "28",
  fill: "none",
  viewBox: "0 0 27 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.782 4.719H7.228a1.7 1.7 0 0 0-1.447.82L.964 13.565a.84.84 0 0 0 0 .868l4.817 8.028a1.7 1.7 0 0 0 1.447.82h15.554a1.687 1.687 0 0 0 1.687-1.688V6.406a1.69 1.69 0 0 0-1.687-1.687m-5.31 11.215a.844.844 0 1 1-1.194 1.194l-1.934-1.935-1.935 1.935a.844.844 0 0 1-1.193-1.194L13.15 14l-1.935-1.934a.844.844 0 0 1 1.193-1.194l1.935 1.935 1.934-1.935a.844.844 0 1 1 1.194 1.194L15.537 14z"
    }, null, -1)
  ])))
}
export default { render: render }